var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExternal6List(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-External_2_List"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19,
    height: 19
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "External_2_List",
    "data-name": "External 2_List",
    clipPath: "url(#clip-External_2_List)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_666",
    "data-name": "Ellipse 666",
    cx: 8.5,
    cy: 8.5,
    r: 8.5,
    transform: "translate(1 1)",
    fill: "#f36d54"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_20391",
    "data-name": "Group 20391",
    transform: "translate(3.74 3.74)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32841",
    "data-name": "Path 32841",
    d: "M9.459,3.049a1.175,1.175,0,0,1,1.662,1.662l-.576.575a.352.352,0,1,0,.5.5l.575-.575A1.88,1.88,0,1,0,8.961,2.551l-1.41,1.41a1.88,1.88,0,0,0,.106,2.756.352.352,0,1,0,.459-.535,1.175,1.175,0,0,1-.067-1.723l1.41-1.41Z",
    transform: "translate(-2.65)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32842",
    "data-name": "Path 32842",
    d: "M6.513,7.867a.352.352,0,1,0-.459.535,1.175,1.175,0,0,1,.067,1.723l-1.41,1.41A1.175,1.175,0,1,1,3.049,9.873L3.625,9.3a.352.352,0,1,0-.5-.5l-.575.575a1.88,1.88,0,1,0,2.658,2.658l1.41-1.41a1.88,1.88,0,0,0-.106-2.756Z",
    transform: "translate(0 -3.065)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExternal6List);
export default __webpack_public_path__ + "static/media/External 6_List.3df348c0ac08b0c2e885e6b651a9d9b0.svg";
export { ForwardRef as ReactComponent };